import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {FurnitureModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function editFurnitureService(dto: FurnitureModel) {
  return await axios.put<ResponseObject<FurnitureModel>>(
    `${BASEURL}/furniture/updateFurniture`,
    dto,
  )
}
